import templateUrl from './shippingOperationEntriesDialog.html'
import './shippingOperationEntriesDialog.scss'
import { tmrDialogController } from 'tmr/controllers/dialog/dialog'

/**
 * Configures dialog with a list of Entries from a ShippingParcel.shippingOperationParcel
 * (inbound, outbound...)
 *
 * @type {ngConfig}
 */
function tmrShippingOperationEntriesDialogConfig($mdDialogProvider) {
  'ngInject'
  $mdDialogProvider.addPreset('tmrShippingOperationEntries', {
    options: /*@ngInject*/ () => ({
      templateUrl,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: 'tmrShippingOperationEntriesDialogController',
      controllerAs: '$ctrl',
      bindToController: true,
      locals: {
        shippingOperationParcel: null,
        code: null,
        description: null,
        color: null,
        size: null,
      },
    }),
  })
}

export { tmrShippingOperationEntriesDialogConfig as config }

/**
 * Controller of Dialog {@link tmrShippingOperationEntriesDialogConfig tmrShippingOperationEntries}.
 *
 * @type {ngController}
 */
export class tmrShippingOperationEntriesDialogController extends tmrDialogController {
  constructor(
    $mdDialog,
    $transitions,
    TmrInfiniteScrollResources,
    ShippingEntry
  ) {
    'ngInject'
    super($mdDialog, $transitions)
    Object.assign(this, { TmrInfiniteScrollResources, ShippingEntry })
  }

  $onInit() {
    super.$onInit()
    this.entries = new this.TmrInfiniteScrollResources(this.ShippingEntry, {
      'operationParcel.id': this.shippingOperationParcel.id,
      upcs: [this.code],
    })
  }
}
